module.exports = __webpack_public_path__ + "img/0Q3A2361_L_Wood_MockedUp.d49f7412.jpg";